import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { Epic } from 'models/meta/epic';

import { addCompanyIdToQueryParams } from 'store/common.helpers';

import {
    fetchTransactionDetailsFailure,
    fetchTransactionDetailsSuccess,
    fetchTransactionsListFailure,
    fetchTransactionsListSuccess,
} from './actions';
import {
    FETCH_TRANSACTION_DETAILS,
    FETCH_TRANSACTIONS_LIST,
} from './actions.types';


export const onFetchTransactionsList: Epic = (
    action$,
    state$,
    { transactions },
) =>
    action$.pipe(
        ofType(FETCH_TRANSACTIONS_LIST),
        switchMap(({ payload: { locationPathname, queryParams } }) =>
            from(
                transactions.getAllTransactions(
                    addCompanyIdToQueryParams({ state$, queryParams }),
                ),
            ).pipe(
                switchMap((response) =>
                    of(
                        fetchTransactionsListSuccess({
                            items: response.data.rows,
                            totalCount: response?.data.count,
                            locationPathname,
                        }),
                    ),
                ),
                catchError(() => of(fetchTransactionsListFailure(locationPathname))),
            ),
        ),
    );

export const onFetchTransactionDetails: Epic = (
    action$,
    state$,
    { transactions },
) =>
    action$.pipe(
        ofType(FETCH_TRANSACTION_DETAILS),
        switchMap(({ payload: { id } }) =>
            from(transactions.getTransactionById(id)).pipe(
                switchMap((response) =>
                    of(fetchTransactionDetailsSuccess(response.data)),
                ),
                catchError((error) => of(fetchTransactionDetailsFailure({ error }))),
            ),
        ),
    );

export default [onFetchTransactionsList, onFetchTransactionDetails];
